export const enum TabType {
  PRODUCT_DETAIL_INFO = 0,
  SIZE_INFO = 1,
  REVIEW = 2,
  RECOMMEND = 3,
  CONTACT = 4,
  BEAUTY_INGREDIENT = 5,
}

export const TabTypeValue = {
  PRODUCT_DETAIL_INFO: 0,
  SIZE_INFO: 1,
  REVIEW: 2,
  RECOMMEND: 3,
  CONTACT: 4,
  BEAUTY_INGREDIENT: 5,
} as const;

export const PAGE_ID: Record<TabType, string> = {
  [TabType.PRODUCT_DETAIL_INFO]: 'detail',
  [TabType.SIZE_INFO]: 'size',
  [TabType.REVIEW]: 'review',
  [TabType.RECOMMEND]: 'recommendation',
  [TabType.CONTACT]: 'inquiry',
  [TabType.BEAUTY_INGREDIENT]: 'beauty_ingredient',
} as const;
